import React, {useState, useContext} from 'react';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {CKEditor} from "@ckeditor/ckeditor5-react";
import BalloonBlock from "@ckeditor/ckeditor5-build-balloon-block";
import '../styles/patientSurgicalHistory.css';
import {NetworkContext} from "../utils/NetworkContext";

function PatientSurgicalHistory({width, setPatient, patient, setDraft, locale}) {
    const {wsCall} = useContext(NetworkContext);
    const [psh, setPsh] = useState(patient.psh);

    const EditorChange = data => {
        setPsh(data);

        if (data && data.length % 10 === 0) {
            const item = {...patient};
            item.psh = data;
            setPatient(item);

            const message = {
                type: 'wss',
                path: 'patient',
                action: 'update',
                data: {
                    patient: patient.id,
                    psh: data
                }
            };
            wsCall(message);
        }
    }

    const EditorBlur = () => {
        setDraft(false);

        const item = {...patient};
        item.psh = psh;
        setPatient(item);

        const message = {
            type: 'wss',
            path: 'patient',
            action: 'update',
            data: {
                patient: patient.id,
                psh: psh
            }
        };
        wsCall(message);
    }

    return (
        <div className="cs-patient-surgical-history-page">
            {width > 768 &&
                <div className="mbsc-row cs-patient-surgical-history-title" />
            }
            <CKEditor
                id="editor-focus"
                config={{
                    toolbar: ['bold', 'italic', 'link'],
                    blockToolbar: ['heading', '|', 'bold', 'italic', 'link', 'blockQuote', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo'],
                    placeholder: locale.patientSurgicalHistory.a
                }}
                editor={BalloonBlock}
                data={psh}
                onChange={(event, editor) => EditorChange(editor.getData())}
                onBlur={() => psh !== patient.psh ? EditorBlur() : null}
            />
            <div className="mbsc-row cs-patient-surgical-history-footer" />
        </div>
    );
}

export default PatientSurgicalHistory;
